import { axiosInstance } from "../axios";

export const cauHinhBaoCaoNVLApi = {
  getAllTypes: () => axiosInstance.get("/report-materials/types"),
  getPaginate: (params) => axiosInstance.get("/report-materials", { params }),
  update: (reportType, nvlIds) =>
    axiosInstance.post(
      "/report-materials/batch",
      nvlIds.map((nvlId) => ({
        nvl_id: nvlId,
        report_type: reportType,
      })),
    ),
  delete: (id) => axiosInstance.delete(`/report-materials/${id}`),
};
